import { Controller } from 'stimulus';

// Floating "unseen announcement" toast. Handles the entrance animation and the
// dismiss for on_post_open posts (which must NOT mark the post seen — just hide
// it for this session; it reappears on the next page load until actually read).
// For on_open / on_impression posts the "×" is a button_to that marks seen + refreshes.
export default class extends Controller {
  static values = { viewTracking: String };

  connect() {
    this.element.classList.add('translate-y-3', 'opacity-0');
    requestAnimationFrame(() => {
      this.element.classList.add('transition', 'duration-300', 'ease-out');
      this.element.classList.remove('translate-y-3', 'opacity-0');
    });
  }

  dismiss() {
    this.element.remove();
  }
}
